/**
 * One auto-synced gift bag (Size S or M) from theme settings, based on
 * line item properties[_gift_warehouse]: agan | jerusalem | both
 */
(function () {
  var syncing = false;
  var PROP_WAREHOUSE = '_gift_warehouse';
  var PROP_VARIANT = '_gift_bag_variant';
  var PROP_AUTO = '_auto_gift_bag';
  var OPT_OUT_KEY = 'giftBagManualRemove';

  function getGiftConfig() {
    return window.theme && window.theme.giftBag ? window.theme.giftBag : null;
  }

  function setGiftBagOptOut() {
    try {
      sessionStorage.setItem(OPT_OUT_KEY, '1');
    } catch (e) {}
  }

  function clearGiftBagOptOut() {
    try {
      sessionStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}
  }

  function isGiftBagOptOut() {
    try {
      return sessionStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function findCartLine(cart, key) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) return items[i];
    }
    return null;
  }

  function hookChangeItem() {
    if (!window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') return;
    if (theme.cart._giftBagChangeHooked) return;
    theme.cart._giftBagChangeHooked = true;
    var original = theme.cart.changeItem.bind(theme.cart);
    theme.cart.changeItem = function (key, qty) {
      if (qty !== 0) return original(key, qty);
      var cfg = getGiftConfig();
      if (!cfg) return original(key, qty);
      return theme.cart.getCart().then(function (cartBefore) {
        var line = findCartLine(cartBefore, key);
        var wasAuto = line && isAutoGiftLine(line, cfg);
        return original(key, qty).then(function (cart) {
          if (wasAuto && !syncing) setGiftBagOptOut();
          return cart;
        });
      });
    };
  }

  function initGiftBagCheckbox() {
    document.querySelectorAll('[data-gift-bag-row]').forEach(function (row) {
      var cb = row.querySelector('.gift_bag_checkbox');
      var hid = row.querySelector('.gift_warehouse_prop');
      var variantHid = row.querySelector('.gift_bag_variant_prop');
      if (!cb || !hid || cb.dataset.giftBagInit) return;
      cb.dataset.giftBagInit = '1';

      function syncHidden() {
        var t = hid.getAttribute('data-warehouse-type') || '';
        if (cb.checked) {
          hid.disabled = false;
          hid.value = t;
          if (variantHid) {
            variantHid.disabled = false;
          }
        } else {
          hid.disabled = true;
          hid.value = '';
          if (variantHid) {
            variantHid.disabled = true;
          }
        }
      }

      cb.addEventListener('change', function () {
        if (cb.checked) clearGiftBagOptOut();
        syncHidden();
        if (typeof window.refreshProductDisplayPrice === 'function') {
          window.refreshProductDisplayPrice();
        }
        document.dispatchEvent(new CustomEvent('giftBag:change', { detail: { checked: cb.checked } }));
      });
      syncHidden();
    });
  }

  function cartHasWarehouseFlags(items) {
    var hasAgan = false;
    var hasJerusalem = false;
    (items || []).forEach(function (line) {
      var p = line.properties && line.properties[PROP_WAREHOUSE];
      if (!p) return;
      if (p === 'agan') hasAgan = true;
      else if (p === 'jerusalem') hasJerusalem = true;
      else if (p === 'both') {
        hasAgan = true;
        hasJerusalem = true;
      }
    });
    return { hasAgan: hasAgan, hasJerusalem: hasJerusalem };
  }

  function targetVariantId(cfg, hasAgan, hasJerusalem) {
    if (hasAgan && hasJerusalem) return cfg.mediumVariantId || cfg.smallVariantId;
    if (hasJerusalem) return cfg.mediumVariantId || cfg.smallVariantId;
    if (hasAgan) return cfg.smallVariantId || cfg.mediumVariantId;
    return null;
  }

  function parseVariantId(raw) {
    if (raw == null || raw === '') return null;
    var id = parseInt(String(raw), 10);
    return id > 0 ? id : null;
  }

  function variantSizeRank(id, cfg) {
    if (!id) return -1;
    if (cfg.mediumVariantId && id === cfg.mediumVariantId) return 2;
    if (cfg.smallVariantId && id === cfg.smallVariantId) return 1;
    return 0;
  }

  function pickLargerVariantId(ids, cfg) {
    var best = null;
    var bestRank = -1;
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      if (!id) continue;
      var rank = variantSizeRank(id, cfg);
      if (rank > bestRank) {
        bestRank = rank;
        best = id;
      }
    }
    return best;
  }

  function collectWarehouseVariantOverrides(items) {
    var overrides = [];
    (items || []).forEach(function (line) {
      var wh = line.properties && line.properties[PROP_WAREHOUSE];
      if (!wh) return;
      var overrideId = parseVariantId(line.properties && line.properties[PROP_VARIANT]);
      if (overrideId) overrides.push(overrideId);
    });
    return overrides;
  }

  function resolveTargetVariantId(items, cfg) {
    var flags = cartHasWarehouseFlags(items);
    if (!flags.hasAgan && !flags.hasJerusalem) return null;

    if (flags.hasAgan && flags.hasJerusalem) {
      var combined = pickLargerVariantId(collectWarehouseVariantOverrides(items), cfg);
      if (combined) return combined;
      return targetVariantId(cfg, flags.hasAgan, flags.hasJerusalem);
    }

    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      var wh = line.properties && line.properties[PROP_WAREHOUSE];
      if (wh !== 'jerusalem' && wh !== 'both' && wh !== 'agan') continue;
      var overrideId = parseVariantId(line.properties && line.properties[PROP_VARIANT]);
      if (overrideId) return overrideId;
    }

    return targetVariantId(cfg, flags.hasAgan, flags.hasJerusalem);
  }

  function isAutoGiftLine(line, cfg) {
    if (!cfg || !cfg.productId || line.product_id !== cfg.productId) return false;
    var a = line.properties && String(line.properties[PROP_AUTO] || '');
    return a === '1' || a === 'true';
  }

  function addGiftBag(variantId) {
    var props = {};
    props[PROP_AUTO] = '1';
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: props }]
      })
    }).then(function (r) {
      return r.json();
    });
  }

  function changeQty(key, qty) {
    return theme.cart.changeItem(key, qty);
  }

  /**
   * Remove one or more lines in a single /cart/update.js round-trip (faster than
   * chaining /cart/change.js per line).
   */
  function removeLinesBatch(lines) {
    if (!lines || !lines.length) {
      return Promise.resolve(null);
    }
    if (lines.length === 1) {
      return changeQty(lines[0].key, 0);
    }
    var updates = {};
    lines.forEach(function (line) {
      updates[line.key] = 0;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.json();
    });
  }

  /**
   * @param {{ refreshCart?: boolean, cart?: object }} opts
   *   opts.cart — cart JSON from a recent change/add (skips an extra GET /cart.js).
   */
  function syncGiftBag(opts) {
    opts = opts || {};
    var cfg = getGiftConfig();
    if (!cfg || !cfg.productId) {
      return Promise.resolve(false);
    }
    if (syncing) return Promise.resolve(false);
    syncing = true;

    var hinted = opts.cart && Array.isArray(opts.cart.items);
    var cartPromise = hinted ? Promise.resolve(opts.cart) : theme.cart.getCart();

    return cartPromise
      .then(function (cart) {
        var items = cart.items || [];
        var flags = cartHasWarehouseFlags(items);
        var want = flags.hasAgan || flags.hasJerusalem;
        var targetId = want ? resolveTargetVariantId(items, cfg) : null;
        var autoLines = items.filter(function (line) {
          return isAutoGiftLine(line, cfg);
        });
        var changed = false;

        if (!targetId) {
          if (!autoLines.length) return false;
          changed = true;
          return removeLinesBatch(autoLines).then(function () {
            return changed;
          });
        }

        var toRemove = autoLines.filter(function (line) {
          return line.variant_id !== targetId || line.quantity !== 1;
        });
        var sameTarget = autoLines.filter(function (line) {
          return line.variant_id === targetId;
        });

        if (sameTarget.length > 1) {
          sameTarget.slice(1).forEach(function (line) {
            toRemove.push(line);
          });
        }

        var seenKeys = {};
        toRemove = toRemove.filter(function (line) {
          if (seenKeys[line.key]) return false;
          seenKeys[line.key] = true;
          return true;
        });

        var start = Promise.resolve(false);
        if (toRemove.length) {
          changed = true;
          start = removeLinesBatch(toRemove).then(function () {
            return true;
          });
        }

        return start.then(function () {
          if (toRemove.length) {
            return theme.cart.getCart();
          }
          return cart;
        }).then(function (cart2) {
          var items2 = cart2.items || [];
          var auto2 = items2.filter(function (line) {
            return isAutoGiftLine(line, cfg);
          });
          var good = auto2.filter(function (line) {
            return line.variant_id === targetId && line.quantity === 1;
          });
          if (good.length === 1) return changed;
          var removeRest = auto2.map(function (line) {
            return line;
          });
          if (!removeRest.length && isGiftBagOptOut()) {
            return changed;
          }
          changed = true;
          return removeLinesBatch(removeRest).then(function () {
            return addGiftBag(targetId).catch(function () {
              return null;
            });
          }).then(function () {
            return changed;
          });
        });
      })
      .catch(function () {
        return false;
      })
      .then(function (changed) {
        syncing = false;
        if (changed && opts.refreshCart) {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
        return changed;
      });
  }

  /**
   * Remove links use GET /cart/change?id=…&quantity=0 (full navigation), so the
   * cart drawer never fires cart:updated. Intercept and use the Cart API instead.
   */
  function interceptCartLineRemoveLinks() {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest && e.target.closest('a');
        if (!a || !a.getAttribute('href')) return;
        var href = a.getAttribute('href');
        if (href.indexOf('cart/change') === -1) return;
        var url;
        try {
          url = new URL(href, window.location.origin);
        } catch (err) {
          return;
        }
        if (url.pathname.indexOf('cart/change') === -1) return;
        var quantity = url.searchParams.get('quantity');
        if (quantity !== '0') return;
        var key = url.searchParams.get('id');
        if (!key || !window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') {
          return;
        }
        e.preventDefault();
        theme.cart
          .changeItem(key, 0)
          .then(function (cart) {
            return typeof theme.syncGiftBag === 'function'
              ? theme.syncGiftBag({ refreshCart: false, cart: cart })
              : Promise.resolve();
          })
          .catch(function () {})
          .finally(function () {
            document.dispatchEvent(new CustomEvent('cart:build'));
          });
      },
      true
    );
  }

  function interceptGiftBagFormSubmit() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector || !form.querySelector('[data-gift-bag-row]')) return;
        var cb = form.querySelector('.gift_bag_checkbox');
        var hid = form.querySelector('.gift_warehouse_prop');
        if (cb && cb.checked && hid && !hid.disabled && hid.value) {
          clearGiftBagOptOut();
        }
      },
      true
    );
  }

  hookChangeItem();
  interceptCartLineRemoveLinks();
  interceptGiftBagFormSubmit();

  document.addEventListener('DOMContentLoaded', function () {
    hookChangeItem();
    initGiftBagCheckbox();
    if (typeof window.refreshProductDisplayPrice === 'function') {
      window.refreshProductDisplayPrice();
    }
  });
  document.addEventListener('shopify:section:load', initGiftBagCheckbox);

  window.theme = window.theme || {};
  window.theme.syncGiftBag = syncGiftBag;

  document.addEventListener('cart:updated', function (ev) {
    var c = ev.detail && ev.detail.cart;
    syncGiftBag({ refreshCart: true, cart: c });
  });

  document.addEventListener('page:loaded', function () {
    if (!document.body.classList.contains('template-cart')) return;
    if (typeof theme.syncGiftBag !== 'function') return;
    theme.syncGiftBag({ refreshCart: true }).catch(function () {});
  });
})();
